<mat-spinner *ngIf="loading" class="loading-spinner" [diameter]="70"></mat-spinner>

<div class="content">
    <div class="product-content" *ngIf="productDetail">
        <mat-icon class="icon" (click)="goBack()">arrow_back</mat-icon>
        <div class="product-detail-container">
            <div class="left-section">
                <div class="product-image-content">
                    <app-product-image-gallery
                        [showWishlistIcon]="false"
                        [show360View]="true"
                        [productId]="productId"
                        class="product-image-gal"
                    ></app-product-image-gallery>
                </div>

                <div class="details-section-content">
                    <div class="details-section">
                        <span class="product-name">
                            {{ productDetail.name }}
                            <span *ngIf="productDetail.modelQuantityJson">
                                ({{ productDetail.modelQuantityJson.totalBlock }}
                                {{ "productDetails.shape" | translate }})
                            </span>
                        </span>
                        <div class="description-content">
                            <p class="description">
                                {{ productDetail.description }}
                            </p>
                        </div>
                        <div class="price-container">
                            <div>
                                <span
                                    class="discounted-price"
                                    *ngIf="
                                        productDetail.discountedPrice &&
                                        productDetail.discountedPrice !== 0 &&
                                        productDetail.discountedPrice !== productDetail.price
                                    "
                                >
                                    {{ "currency.rs" | translate }}
                                    {{ productDetail.discountedPrice }}
                                </span>
                                <span
                                    class="price"
                                    [ngClass]="{
                                        'cut-price':
                                            productDetail.discountedPrice &&
                                            productDetail.discountedPrice !== 0 &&
                                            productDetail.discountedPrice !== productDetail.price
                                    }"
                                >
                                    {{ "currency.rs" | translate }} {{ productDetail.price }}
                                </span>
                                &nbsp;
                                <span
                                    class="discount-percentage"
                                    *ngIf="
                                        productDetail.discountedPrice &&
                                        productDetail.discountedPrice !== productDetail.price
                                    "
                                    >{{ productDetail.discountPercentage }}% {{ "productOffer.off" | translate }}</span
                                >
                                <p class="text-color">
                                    {{ "productDetails.taxesMessage" | translate }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="rating-info">
                <div class="rating-top">
                    <span class="rating-heading">{{ "userReviewPage.label.rating" | translate }}</span>
                    <div class="rating">
                        <div class="rating-left-section">
                            <div class="rating-star-container">
                                <span class="rating-count">{{ productDetail.averageRating }}</span>
                                <mat-icon class="top-section-rating-icon">star</mat-icon>
                            </div>
                            <p>{{ "userReviewPage.label.verified" | translate }}</p>
                        </div>

                        <div class="rating-right-section">
                            @for (item of distributionEntries; track $index) {
                            <div class="rating-bar-row">
                                <div class="count-rating-content">
                                    <span>{{ item[0] }}</span
                                    ><mat-icon class="rating-star">star</mat-icon>
                                </div>
                                <div class="bar-container">
                                    <div
                                        class="bar-filled"
                                        [ngStyle]="{ width: (item[1] / totalcount) * 100 + '%' }"
                                    ></div>
                                </div>
                                <span>{{ item[1] }}</span>
                            </div>
                            }
                        </div>
                    </div>
                    <div class="separator"></div>
                </div>

                <div class="customer-reviews-section">
                    <div class="customer-review-heading">
                        <span class="review-heading">{{ "userReviewPage.label.customerReviews" | translate }}</span>
                    </div>

                    <div class="customer-reviews">
                        @for (review of reviews; track $index) {
                        <div class="review-content" *ngIf="review.review">
                            <div class="review-left-section">
                                <div class="rating-star-content">
                                    <span>{{ review.rating }}</span
                                    ><mat-icon class="user-rating-star">star</mat-icon>
                                </div>
                            </div>

                            <div class="review-right-section">
                                <p>{{ review.review }}</p>
                                <div *ngIf="review.images" class="images">
                                    @for (image of review.images.imagesUrl; track $index) {
                                    <img [src]="image" class="user-review-image" (click)="onClickImage([image])" />
                                    }
                                </div>
                                <div>
                                    <span>{{ review.name }}</span
                                    >|<span>{{ review.createdAt | date: "dd MMM YYYY" }}</span>
                                </div>
                            </div>
                        </div>
                        }
                    </div>

                    <div class="btn-container" *ngIf="this.totalcount - this.reviews.length > 0">
                        <app-button variant="hero" buttonClass="explore-btn shadow-btn" (onClick)="onViewMoreClick()">
                            {{ "userReviewPage.button.viewMore" | translate }}
                        </app-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
